<template>
  <section class="content-plans">
    <div class="content-plans-itens">
      <Breadcrumb :links="links" />
      <div class="content-plans-itens-body">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-6 col-xl-4 col-xl-3">
            <router-link
              tag="a"
              :to="{ name: 'RegisterPosition' }"
              class="content--card-register"
              style="min-height: 200px"
            >
              <img
                class="img-fluid"
                src="@/assets/img/image-plus.png"
                alt="image plus"
                title="image plus"
              />
            </router-link>
          </div>
          <template v-if="hasPositions">
            <div
              class="col-12 col-sm-6 col-lg-6 col-xl-4 col-xl-3"
              v-for="position in positions"
              :key="position.id"
            >
              <CardPosition :position="position" />
            </div>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Index";
import CardPosition from "@/views/Company/components/CardPosition";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      links: [
        {
          name: "Empresas",
          routerName: "Company",
        },
        {
          name: "Listar Cargos",
          routerName: "ListPositions",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      positions: "Company/positions",
    }),
    hasPositions() {
      return (
        this.positions &&
        Array.isArray(this.positions) &&
        this.positions.length > 0
      );
    },
  },
  components: {
    Breadcrumb,
    CardPosition,
  },
  methods: {
    ...mapActions("Company", ["consultPositions"]),
  },
  mounted() {
    this.consultPositions();
  },
};
</script>
